import { Button } from "@papier/ui/components/ui/button";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@papier/ui/components/ui/drawer";
import { Label } from "@papier/ui/components/ui/label";
import { createFileRoute, Link, linkOptions, Outlet, useLocation } from "@tanstack/react-router";
import { MenuIcon } from "lucide-react";
import { useState } from "react";

export const Route = createFileRoute("/_app/organization")({
  component: RouteComponent,
  head: () => ({
    meta: [{ title: "Organization" }],
  }),
});

const navItems = linkOptions([
  { to: "/organization/settings", label: "Settings" },
  { to: "/organization/members", label: "Members" },
  { to: "/organization/api-keys", label: "API Keys" },
  { to: "/organization/billing", label: "Billing" },
]);

function RouteComponent() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();

  return (
    <main className="flex flex-col gap-4 md:flex-row md:gap-12">
      <nav className="top-18 sticky hidden max-h-max md:block">
        <div className="flex w-48 flex-col gap-1 lg:w-60">
          {navItems.map((item) => (
            <Button
              variant="ghost"
              asChild
              key={item.label}
              className="text-foreground/70 w-full justify-start px-4 transition-none"
            >
              <Link
                key={item.label}
                to={item.to}
                activeProps={{ className: "!text-foreground font-semibold" }}
              >
                {item.label}
              </Link>
            </Button>
          ))}
        </div>
      </nav>

      <div className="flex justify-between gap-2 md:hidden">
        <Label className="text-base font-semibold">
          {navItems.find((i) => location.pathname === i.to)?.label}
        </Label>

        <Drawer open={drawerOpen} onOpenChange={setDrawerOpen} autoFocus={drawerOpen}>
          <DrawerTrigger asChild>
            <Button variant="outline">
              <MenuIcon />
            </Button>
          </DrawerTrigger>

          <DrawerContent>
            <DrawerHeader>
              <DrawerTitle className="sr-only">Organization</DrawerTitle>
              <DrawerDescription className="sr-only">
                Organization settings and management
              </DrawerDescription>
            </DrawerHeader>
            <nav className="flex flex-col px-4 pb-5">
              {navItems.map((item) => (
                <Button
                  onClick={() => setDrawerOpen(false)}
                  variant="ghost"
                  size="lg"
                  asChild
                  key={item.label}
                  className="text-foreground/70 w-full justify-start px-4 transition-none"
                >
                  <Link
                    key={item.label}
                    to={item.to}
                    activeProps={{ className: "!text-foreground font-semibold" }}
                  >
                    {item.label}
                  </Link>
                </Button>
              ))}
            </nav>
          </DrawerContent>
        </Drawer>
      </div>

      <div className="w-full">
        <Outlet />
      </div>
    </main>
  );
}
